import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { getIsGlifeContext } from '../selectors/settings-selectors';
import { AppMode } from '../http/protocol';
import { getAppMode } from '../selectors/user-selectors';
import { useHistory } from 'react-router';
import useGlifeCommunication from './useGlifeCommunication';

export default function useGlifeLinkEvents() {
    const isGlifeAppContext = useSelector(getIsGlifeContext);
    const isEmbeddedAppMode = useSelector(getAppMode) === AppMode.EMBEDDED;
    const { handleOpenExternalLink } = useGlifeCommunication();

    useEffect(() => {
        const handleClick = (event: MouseEvent | PointerEvent | TouchEvent) => {
            const target = (event.target as HTMLElement).closest("a");

            if (target && target instanceof HTMLAnchorElement && target.href) {
                const linkUrl = new URL(target.href);

                if (linkUrl.origin !== window.location.origin) {
                    console.log("External link clicked:", target.href);
                    event.preventDefault();
                    handleOpenExternalLink(target.href);
                }
            }
        };
        if (isGlifeAppContext && isEmbeddedAppMode) {
            document.body.addEventListener("click", handleClick);
            return () => document.body.removeEventListener("click", handleClick);
        }
    }, [isGlifeAppContext, isEmbeddedAppMode]);

}